import type { getClaimAuditGroupsQueryVariables } from "@alaffia-technology-solutions/client-sdk";

import { createMutationHook, createQueryHook } from "../factory";

interface GetClaimAuditGroupCommentsInput extends Record<string, unknown> {
  id: string;
}

type GetClaimAuditGroupsInput = getClaimAuditGroupsQueryVariables &
  Record<string, unknown>;

const auditKeys = {
  all: ["audits"] as const,
  claimAuditGroups: () => [...auditKeys.all, "claimAuditGroups"] as const,
  claimAuditGroupsList: (input: GetClaimAuditGroupsInput) =>
    [...auditKeys.claimAuditGroups(), "list", input] as const,
  claimAuditGroupComments: (input: GetClaimAuditGroupCommentsInput) =>
    [...auditKeys.claimAuditGroups(), "comments", input] as const,
  denialCodes: () => [...auditKeys.all, "denialCodes"] as const,
};

export const audits = {
  getClaimAuditGroups: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.audits.getClaimAuditGroups,
    queryKeyFn: auditKeys.claimAuditGroupsList,
  }),
  getAuditFindingRuleTypes: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.getAuditFindingRuleTypes,
    queryKeyFn: auditKeys.denialCodes,
  }),
  createClaimAuditGroup: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.createClaimAuditGroup,
    mutationKey: ["audits", "createClaimAuditGroup"],
  }),
  deleteClaimAuditGroup: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.deleteClaimAuditGroup,
    mutationKey: ["audits", "deleteClaimAuditGroup"],
  }),
  assignClaimsToAuditGroup: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.assignClaimsToAuditGroup,
    mutationKey: ["audits", "assignClaimsToAuditGroup"],
  }),
  unassignClaimsFromAuditGroup: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.unassignClaimsFromAuditGroup,
    mutationKey: ["audits", "unassignClaimsFromAuditGroup"],
  }),
  updateClaimAuditGroup: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.updateClaimAuditGroup,
    mutationKey: ["audits", "updateClaimAuditGroup"],
  }),
  getClaimAuditGroupComments: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.getClaimAuditGroupComments,
    queryKeyFn: auditKeys.claimAuditGroupComments,
  }),
  createClaimAuditGroupComment: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.createClaimAuditGroupComment,
    mutationKey: ["audits", "createClaimAuditGroupComment"],
  }),
  createReviewedAuditFinding: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.audits.createReviewedAuditFinding,
    mutationKey: ["audits", "createReviewedAuditFinding"],
  }),
};
